import { Routes, mapToCanActivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { FarmerInsightsComponent } from './farmer-insights.component';
import { FarmerInsightsGuard } from './guards/farmer-insights.guard';

export const farmerInsightsRoutes: Routes = [
  {
    path: 'farmer-insights',
    component: FarmerInsightsComponent,
    canActivate: mapToCanActivate([LocationGuard, FarmerInsightsGuard]),
    data: { name: 'data-view' },
  },
];
